"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../../styles");
var GameSeed = /** @class */ (function (_super) {
    __extends(GameSeed, _super);
    function GameSeed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSeed.prototype.render = function () {
        return (React.createElement("p", { key: 'game-seed' },
            "Seed:",
            React.createElement("input", { type: 'text', id: 'game-seed', style: Styles.gameSeedInput, value: this.props.value, onChange: this.props.onChange }),
            React.createElement("img", { src: '/img/dice.png', style: Styles.gameSeedGenerate, onClick: this.props.onGenerate, title: 'Generate new seed!', alt: 'generate new seed' })));
    };
    return GameSeed;
}(React.Component));
exports.GameSeed = GameSeed;
//# sourceMappingURL=GameSeed.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Setup/GameSeed.js
// module id = 32
// module chunks = 0